import angular from 'angular';
import ScheduledAnnouncementsComponent from './scheduled-announcements-component';

export default angular.module('scheduled-announcements', []).component('scheduledAnnouncements', new ScheduledAnnouncementsComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/scheduled-announcements/scheduled-announcements-module.js